import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { PiDotsThree } from "react-icons/pi";
import {
  FaBookmark,
  FaRegBookmark,
  FaLink,
  FaEdit,
  FaTrash,
  FaCommentSlash,
} from "react-icons/fa";
import EditPostModal from "../Modals/EditPost/EditPostModal";
import axios from "axios";
import BaseUrl from "./BaseUrl";
import Cookies from "js-cookie";
const PostHeader = ({ post, groupData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [showOptions, setShowOptions] = useState(false);
  const [isSaved, setIsSaved] = useState(post.is_saved);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);
  const [showEditPostModal, setShowEditPostModal] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        optionsRef.current &&
        buttonRef.current &&
        !optionsRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };

    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  const handleToggleSaveUnsave = async () => {
    setShowOptions(false);
    if (isSaved) {
      const response = await axios.post(
        `${BaseUrl}unsavepost`,
        {
          saved_type: "group_post",
          savable_id: post.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data.status === 200) {
        setIsSaved(!isSaved);
        if (!location.pathname.startsWith("/group")) {
          navigate('/my-items/saved-post', { replace: true });
        }
      }
    } else {
      const response = await axios.post(
        `${BaseUrl}savepost`,
        {
          saved_type: "group_post",
          group_id: groupData.id,
          savable_id: post.id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setIsSaved(!isSaved);
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="p-4">
      <div className="relative flex items-start justify-between space-x-3">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 rounded-full overflow-hidden">
            {post.user_profile ? (
              <img
                src={post.user_profile}
                alt={post.user_name}
                className="w-full h-full object-cover border border-gray-200 rounded-full"
              />
            ) : (
              <div className="w-full h-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                {post.user_name.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
          <div>
            <h3 className="font-semibold">{post.user_name}</h3>
            <p className="text-xs text-gray-500">
              {formatDate(post.created_at)}
              <span className="mx-1">•</span>
              <span>Post</span>
            </p>
          </div>
        </div>

        <PiDotsThree
          className="text-2xl cursor-pointer hover:text-gray-700"
          onClick={() => setShowOptions(!showOptions)}
          ref={buttonRef}
        />

        {showOptions && (
          <div
            ref={optionsRef}
            className="absolute bg-white border border-gray-300 shadow-lg rounded-b-lg rounded-tl-lg z-50 mt-5 w-72 right-0 overflow-hidden"
          >
            <button
              className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
              onClick={handleToggleSaveUnsave}
            >
              {isSaved ? <FaBookmark /> : <FaRegBookmark />}
              {isSaved ? "Unsave" : "Save"}
            </button>

            {/* <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
              <FaLink />
              Copy Link to Post
            </button>

            <button
              className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
              onClick={() => setShowEditPostModal(true)}
            >
              <FaEdit />
              Edit Post
            </button>

            <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
              <FaTrash />
              Delete Post
            </button>

            <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
              <FaCommentSlash />
              Disable Comments on this Post
            </button> */}
          </div>
        )}
      </div>
      {showEditPostModal && (
        <EditPostModal
          open={showEditPostModal}
          postData={post}
          groupData={groupData}
          type={"grouppost"}
          onClose={() => setShowEditPostModal(false)}
        />
      )}
    </div>
  );
};

export default PostHeader;
